import { createContext } from 'react';

export type ContextType = Record<string, string | number>;

export const Context = createContext({} as ContextType);
